import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Home from './pages/home/home';
import Events from './pages/events/events';
import Layout from './components/layout/layout';
import Preloader from './components/loader/preloader';
import EventDetailPage from './pages/eventDetails/EventDetailPage';
import BookingPage from './pages/bookingPage/BookingPage';
import ConfirmBookingPage from './pages/confirmBookingPage/ConfirmBookingPage';
import MyBookingsPage from './pages/myBookingsPage/MyBookingsPage';
import NotFound404 from './components/404Page/NotFound404';
import ProfileForm from './pages/profilePage/ProfileForm';
import ContactUs from './pages/contactUs/ContactUs';
import PrivacyPolicyPage from './pages/privacyPolicyPage/PrivacyPolicyPage';
import TermsAndConditionsPage from './pages/termsAndConditionsPage/TermsAndConditionsPage';
import PaymentPage from './pages/PaymentPage/PaymentPage';
import PaymentSuccess from './pages/confirmBookingPage/PaymentSuccess';
import PaymentError from './pages/confirmBookingPage/PaymentError';
import Ponnonam2025 from './pages/events/mauk/Ponnonam2025';
import ReadOnlyBookingPage from './pages/bookingPage/ReadOnlyBookingPage';
import ResetPasswordPage from './pages/resetPassword/ResetPasswordPage';

// Temporary route restriction component
// const RestrictedRoute = ({ children, allowedPaths }) => {
//   const location = useLocation();
//   const currentPath = location.pathname;
  
//   // Check if current path is in allowed paths
//   const isAllowed = allowedPaths.some(path => {
//     if (path.includes(':')) {
//       // Handle dynamic routes like /view-seats/:eventId
//       const pathPattern = path.replace(/:[^/]+/g, '[^/]+');
//       const regex = new RegExp(`^${pathPattern}$`);
//       return regex.test(currentPath);
//     }
//     return currentPath === path;
//   });
  
//   if (isAllowed) {
//     return children;
//   }
  
//   // Redirect to Ponnonam event for all other routes
//   return <Navigate to="/mauk/ponnonam-2025" replace />;
// };

function App() {
  const [loading, setLoading] = useState(true);

  // Define allowed paths for temporary restriction
  // const allowedPaths = [
  //   '/mauk/ponnonam-2025',
  //   '/view-seats/:eventId',
  //   '/my-bookings',
  //   '/profile', 
  //   '/contact-us',
  //   '/privacy-policy'
  // ];

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      {/* {loading ? <Preloader setLoading={setLoading} /> : ( */}
        <Router>
          <Layout>
            {/* <RestrictedRoute allowedPaths={allowedPaths}> */}
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/events" element={<Events />} />
                <Route path="/mauk/ponnonam-2025" element={<Ponnonam2025 />} />
                <Route path="/events/:eventName" element={<EventDetailPage />} />
                <Route path="/booking/:eventName" element={<BookingPage />} />
                <Route path="/view-seats/:eventName" element={<ReadOnlyBookingPage />} />
                <Route path="/confirm-booking/:eventName" element={<ConfirmBookingPage />} />
                <Route path="/my-bookings" element={<MyBookingsPage />} />
                <Route path="/profile" element={<ProfileForm />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
                <Route path="/payment/:eventName" element={ <PaymentPage />} />
                <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path="/payment-error" element={<PaymentError />} />
                <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
                {/* Add more routes as needed */}
                <Route path="*" element={<NotFound404 />} />

              </Routes>
          </Layout>
        </Router>
      {/* )} */}
    </GoogleOAuthProvider>
  );
}

export default App;
